import { gql } from '@apollo/client'

export const DASHBOARD_IMPACT_REPORT = gql`
  query dashboardImpactReport($nonprofitOrgId: Int!) {
    dashboardImpactReport(nonprofitOrgId: $nonprofitOrgId) {
      reportEndDate
      reportStartDate
      impactGoalsUrl
      showEmptyState
      goalsPrioritizedByTaskCreateDate {
        goalId
        goalTitle
        numTasks
        numTasksCompleted
        goalLink
      }
      funderCollaboratedGoals {
        goalId
        goalTitle
        goalLink
        updatedAt
      }
      tasksSummary {
        totalTasksAssigned
        totalTasksUnassigned
        totalTasks
        totalTasksCompletedOverall
        totalTasksCompletedThisReportPeriod
      }
      pastReportPeriodActivity {
        academyResourcesViewed
        goalCategory
        goalsCreated
        tasksCompleted
      }
    }
  }
`
